import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/heroCarousel/heroCarousel.js';
import s from 'components/bolt/hub/components/heroCarousel/heroCarousel.sss';
import Store from 'store/store';
import { sortObjectByOrder } from 'utils/utils';
import { getDynamicData } from 'utils/bolt/dynamicData';

export default class HeroCarousel extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();

		const { appData } = Store.get();
		if (appData?.options?.cmsManaged) {
			const activePage = Store.get().activePage;

			switch (activePage) {
				case 'landing':
					await this.loadCustomData(await getDynamicData('landing'));
					break;
				case 'leadership':
					await this.loadCustomData(await getDynamicData('leadership'));
					break;
				case 'aboutUs':
					await this.loadCustomData(await getDynamicData('about-us'));
					break;
				case 'careers':
					await this.loadCustomData(await getDynamicData('careers'));
					break;
			}
		}
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}
		const { appData } = Store.get();
		if (!appData?.options?.cmsManaged || !dynamicData) return;

		this.dynamicData = {
			slides: dynamicData?.hero.map((slide, i) => ({
				title: slide?.title,
				description: slide?.description,
				background: { desktop: slide?.img, mobile: slide?.mobileImg, alt: slide?.alt },
				path: slide?.link,
				buttons: slide?.buttons?.map((button, i) => ({
					label: button?.label,
					link: button?.link,
				}))
			})) || [],
		};
		this.slides = sortObjectByOrder(this.dynamicData.slides);
	}
}
